import { render, staticRenderFns } from "./ChangeEmailModal.vue?vue&type=template&id=6d07b83e&scoped=true"
import script from "./ChangeEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChangeEmailModal.vue?vue&type=style&index=0&id=6d07b83e&prod&scoped=true&lang=css"
import style1 from "./ChangeEmailModal.vue?vue&type=style&index=1&id=6d07b83e&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d07b83e",
  null
  
)

export default component.exports